import {
  USER_CHECK_USERNAME,
  USER_GET_PASSCODE,
  USER_CONFIRM_PASSCODE,
  USER_GET,
  USER_REGISTER,
  USER_GET_EXPERIAN_QUESTIONS,
  USER_ANSWER_EXPERIAN_QUESTIONS,
  USER_SET_ACCOUNT_INFO,
  USER_SETUP_BANK_ACCOUNT_INFO,
  USER_UPLOAD,
  USER_UPDATE,
  USER_UPDATE_PASSWORD,
  USER_REQUEST_PASSWORD_RESET,
  USER_CONFIRM_PASSWORD_RESET,
  USER_SET_CONTEXT,
  USER_REQUEST,
  USER_SUCCESS,
  USER_ERROR,
  AUTH_SUCCESS
} from "@/store/types"

import axios from "@/store/axios"
import _ from "lodash"
import { snakeCase } from "change-case"

//https://gist.github.com/Yimiprod/7ee176597fef230d1451
const difference = (object, base) => {
  function changes(object, base) {
    return _.transform(object, function (result, value, key) {
      if (!_.isEqual(value, base[key])) {
        result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value
      }
    })
  }
  return changes(object, base)
}

const convertToSnakeCase = (object) => {
  const formatted = {}
  Object.keys(object).forEach((key) => {
    formatted[snakeCase(key)] = object[key]
  })
  return formatted
}

const state = {
  checkedUsernameInfo: null,
  user: null,
  isLoading: false,
  error: null,
  experianQuestions: null,
  accountInfo: null,
  context: ""
}

const getters = {
  getCurrentCheckedUsernameInfo: (state) =>
    state.checkedUsernameInfo
      ? state.checkedUsernameInfo.applicant_info
      : state.checkedUsernameInfo,
  isCheckedUsernameAvailable: (state) =>
    state.checkedUsernameInfo ? state.checkedUsernameInfo.available : !!state.checkedUsernameInfo,
  getCurrentUser: (state) => {
    return state.user
  },
  isUserLoading: (state) => state.isLoading,
  getUserError: (state) => state.error,
  getUserExperianQuestions: (state) => state.experianQuestions,
  getUserAccountInfo: (state) => state.accountInfo,
  getCurrentUserContext: (state) => state.context
}

const actions = {
  [USER_GET]: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      axios
        .get(`/api/v3/users/`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(USER_SUCCESS, {
            user: resp.data.results[0]
          })

          if (!state.context) {
            commit(USER_SET_CONTEXT, resp.data.results[0].landlord ? "landlord" : "applicant")
          }

          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_REGISTER]: (
    { commit },
    { email, password, name, userType, companyName, referrer, referrerData }
  ) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      axios
        .post(`/api/v3/users/register/`, {
          username: email,
          password,
          name,
          user_type: userType,
          company_name: companyName,
          referrer,
          referrer_data: referrerData
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(USER_SET_CONTEXT, "landlord")
          commit(USER_SUCCESS, { user: resp.data.user })
          commit(AUTH_SUCCESS, resp.data.token)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_CHECK_USERNAME]: ({ commit }, { username }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      //TODO: Update this to v3 API when available
      axios
        .get(`/api/v3/users/check_available/${username}/`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(USER_SUCCESS, { checked: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_GET_PASSCODE]: ({ commit }, { username }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      //TODO: Update this to v3 API when available
      axios
        .post(`/api/v3/users/request_passcode/`, { email: username })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(USER_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_CONFIRM_PASSCODE]: ({ commit }, { username, passcode }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      //TODO: Update this to v3 API when available
      axios
        .post(`/api/v3/users/confirm_passcode/`, {
          email: username,
          token: passcode
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(USER_SUCCESS, {})
          commit(AUTH_SUCCESS, resp.data.token)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_GET_EXPERIAN_QUESTIONS]: (
    { commit },
    { firstName, lastName, ssn, streetAddress, city, state, zip }
  ) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      axios
        .post(`/api/v3/users/get_experian_questions/`, {
          first_name: firstName,
          last_name: lastName,
          ssn,
          street_address: streetAddress,
          city,
          state,
          zip
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(USER_SUCCESS, { questions: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_ANSWER_EXPERIAN_QUESTIONS]: ({ commit }, { answers }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      axios
        .post(`/api/v3/users/answer_experian_questions/`, {
          answers
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(USER_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_SETUP_BANK_ACCOUNT_INFO]: ({ commit }, { data, token, receipt }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      const formatted = {
        account_type: data.accountType,
        legal_first_name: data.firstName,
        legal_last_name: data.lastName,
        personal_tax_id: data.ssn.replaceAll("-", ""),
        dob: data.dob.replaceAll("/", ""),
        routing_number: data.routingNumber,
        account_number: data.accountNumber
      }

      if (data.accountType === "company") {
        formatted.business_name = data.businessName
        formatted.business_tax_id = data.taxId
        formatted.business_address_line1 = data.companyAddressLine1
        formatted.business_address_line2 = data.companyAddressLine2
        formatted.business_address_city = data.companyAddressCity
        formatted.business_address_state = data.companyAddressState
        formatted.business_address_zip_code = data.companyAddressZip
      }

      axios
        .post(`/api/v3/users/setup_bank_info/`, {
          ...formatted,
          stripeToken: token,
          payment_receipt: receipt
        })
        .then((resp) => {
          console.log(resp)

          commit(USER_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_UPLOAD]: ({ commit }, { logoFile, profilePhotoFile }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      const formData = new FormData()

      if (logoFile) {
        formData.append("file", logoFile)
        formData.append("logo", logoFile.name)
      }

      if (profilePhotoFile) {
        formData.append("file", profilePhotoFile)
        formData.append("profile", profilePhotoFile.name)
      }

      axios
        .post(`/api/v3/users/upload/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(USER_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_UPDATE]: ({ commit, state }, { landlord, notifications }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)
      const formatted = {}

      if (landlord) {
        const diff = difference(convertToSnakeCase(landlord), state.user.landlord)

        if (!_.isEmpty(diff)) {
          formatted.landlord = diff
        }
      }

      if (notifications) {
        const diff = difference(convertToSnakeCase(notifications), state.user.notification_settings)

        if (!_.isEmpty(diff)) {
          formatted.notification_settings = diff
        }
      }

      if (_.isEmpty(formatted)) {
        commit(USER_SUCCESS)
        resolve()
        return
      }

      axios
        .patch(`/api/v3/users/${state.user.id}/`, formatted)
        .then((resp) => {
          console.log(resp)

          commit(USER_SUCCESS, { user: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_UPDATE_PASSWORD]: ({ commit }, { newPassword, currentPassword }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      axios
        .post(`/api/v3/users/update_password/`, {
          new_password: newPassword,
          current_password: currentPassword
        })
        .then((resp) => {
          console.log(resp)

          commit(USER_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_REQUEST_PASSWORD_RESET]: ({ commit }, { email }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      axios
        .post(`/api/v3/users/request_password_reset/`, {
          email
        })
        .then((resp) => {
          console.log(resp)

          commit(USER_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  },
  [USER_CONFIRM_PASSWORD_RESET]: ({ commit }, { token, uidb64, newPassword, matchPassword }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)

      axios
        .post(`/api/v3/users/confirm_password_reset/`, {
          token,
          uidb64,
          new_password: newPassword,
          new_password_again: matchPassword
        })
        .then((resp) => {
          console.log(resp)

          commit(USER_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(USER_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.isLoading = true
  },
  [USER_SUCCESS]: (state, { user, checked, questions } = {}) => {
    state.isLoading = false

    if (user) {
      state.user = user
    }

    if (checked) {
      state.checkedUsernameInfo = checked
    }

    if (questions) {
      state.experianQuestions = questions
    }
  },
  [USER_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
  [USER_SET_ACCOUNT_INFO]: (state, accountInfo) => {
    state.accountInfo = accountInfo
  },
  [USER_SET_CONTEXT]: (state, context) => {
    state.context = context
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
